import styled, { css } from 'styled-components';
import Tooltip from '../../Tooltip';
import * as colors from '../../../config/Colors/Ligth';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: transparent;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;

  border: 1px solid #c4c4c4;
  color: #666360;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.erro};
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: #666360;
      color: #666360;
    `}

  ${props =>
    props.isFocused &&
    css`
      color: #666360;
    `}

  input {
    flex: 1;
    background: transparent;
    border: 0;

    &::placeholder {
      color: #666360;
    }
  }

  svg {
    margin-right: 16px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;
  svg {
    margin: 0;
  }

  span {
    background: ${colors.erro};
    color: #fff;

    &::before {
      border-color: ${colors.erro} transparent;
    }
  }
`;
